import { useMutation, useQuery, useQueryClient } from '@tanstack/react-query'
import { api } from '../../lib/api.js'
import { queryKeys } from '../../lib/hooks.js'

/** The site map, polled while a read of the site is running so the screen picks it up when it lands. */
export function useSiteMap() {
  return useQuery({
    queryKey: queryKeys.siteMap(),
    queryFn: () => api.getSiteMap(),
    refetchInterval: (query) => (query.state.data?.crawl?.running ? 3000 : false),
  })
}

export function useRefreshSiteMap() {
  const queryClient = useQueryClient()
  return useMutation({
    mutationFn: () => api.refreshSiteMap(),
    onSuccess: () => queryClient.invalidateQueries({ queryKey: queryKeys.siteMap() }),
  })
}
